import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, {
    title: "Pulse",
    description: "Configure Pulse behavior for all users."
  }, {
    right: _withCtx(() => [
      _createVNode(_component_Autosave, {
        saving: $data.saving,
        saved_at: $data.saved_at
      }, null, 8 /* PROPS */, ["saving", "saved_at"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_BuilderInputs, {
        class: "builder",
        opts: $data.schema,
        onUpdate: _cache[0] || (_cache[0] = $event => (_ctx.$debounce_500($options.onUpdate)))
      }, null, 8 /* PROPS */, ["opts"])
    ]),
    _: 1 /* STABLE */
  }))
}